import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      needAuth: false,
    },
    {
      path: '/persons',
      name: 'persons',
      component: () => import(/* webpackChunkName: "persons" */ '@/views/Persons.vue'),
      needAuth: true
    },
    {
      path: '/persons/:personid',
      name: 'person',
      component: () => import(/* webpackChunkName: "person" */ '@/views/Person.vue'),
      props: true,
      needAuth: true
    },
    {
      path: '/finances',
      name: 'finances',
      component: () => import(/* webpackChunkName: "finances" */ '@/views/Finances.vue'),
      needAuth: true
    },
    {
      path: '/cafereports',
      name: 'cafereports',
      component: () => import(/* webpackChunkName: "cafereports" */ '@/views/CafeReports.vue'),
      needAuth: true
    },
    {
      path: '/support/chats',
      name: 'chats',
      component: () => import(/* webpackChunkName: "chats" */ '@/views/Chats.vue'),
      needAuth: true
    },
    {
      path: '/support/statements',
      name: 'statements',
      component: () => import(/* webpackChunkName: "statements" */ '@/views/Statements.vue'),
      needAuth: true
    },
    {
      path: '/support/statements/print',
      name: 'printStatement',
      component: () => import(/* webpackChunkName: "printStatement" */ '@/views/PrintStatement.vue'),
      needAuth: true
    },
    {
      path: '/support/chats/:chatid',
      name: 'chat',
      component: () => import(/* webpackChunkName: "chat" */ '@/views/Chat.vue'),
      props: true,
      needAuth: true
    },
    {
      path: '/microservices',
      name: 'microservices',
      component: () => import(/* webpackChunkName: "microservices" */ '@/views/Microservices.vue'),
      needAuth: true
    },
    {
      path: '/cafes',
      name: 'cafes',
      component: () => import(/* webpackChunkName: "cafes" */ '@/views/Cafes.vue'),
      needAuth: true
    },
    {
      path: '/controllers',
      name: 'controllers',
      component: () => import(/* webpackChunkName: "cafes" */ '@/views/Controllers.vue'),
      needAuth: true
    },
    {
      path: '/cards',
      name: 'cards',
      component: () => import(/* webpackChunkName: "cards" */ '@/views/Cards.vue'),
      needAuth: true
    },
    {
      path: '/classheads',
      name: 'classheads',
      component: () => import(/* webpackChunkName: "cards" */ '@/views/Classheads.vue'),
      needAuth: true
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import(/* webpackChunkName: "payments" */ '@/views/Payments.vue'),
      needAuth: true
    },
    {
      path: '/importpersons',
      name: 'importpersons',
      component: () => import(/* webpackChunkName: "importpersons" */ '@/views/ImportPersons.vue'),
      needAuth: true
    },
    {
      path: '/procedures',
      name: 'procedures',
      component: () => import(/* webpackChunkName: "procedures" */ '@/views/Procedures.vue'),
      needAuth: true
    },
    {
      path: '/console',
      name: 'console',
      component: () => import(/* webpackChunkName: "console" */ '@/views/Console.vue'),
      needAuth: true
    },
    {
      path: '/wmreport',
      name: 'wmreport',
      component: () => import(/* webpackChunkName: "wmreport" */ '@/views/WmReport.vue'),
      needAuth: true
    },
    {
      path: '/newsarticles',
      name: 'newsarticles',
      component: () => import(/* webpackChunkName: "newsarticles" */ '@/views/NewsArticles.vue'),
      needAuth: true
    },
    {
      path: '/scheduler',
      name: 'scheduler',
      component: () => import(/* webpackChunkName: "scheduler" */ '@/views/Scheduler.vue'),
      needAuth: true
    },
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      needAuth: true
    },
    {
      path: '/printhtml',
      name: 'printHtml',
      component: () => import(/* webpackChunkName: "printhtml" */ '@/views/PrintHtml.vue'),
      needAuth: true
    },
    {
      path: '/orgs',
      name: 'orgs',
      component: () => import(/* webpackChunkName: "orgs" */ '@/views/Orgs.vue'),
      needAuth: true
    },
    {
      path: '/schooladmins',
      name: 'schooladmins',
      component: () => import(/* webpackChunkName: "SchooladminAccounts" */ '@/views/SchooladminAccounts.vue'),
      needAuth: true
    },
  ]
})
